﻿export default class RTSUpdatePage  {
    constructor() {
        this.updateType = "Biblio";
    }

    initializeUpdate = () => {
        $(document).ready(() => {
            rtsUpdatePage.loadUpdateScreen("Biblio");

            //$("#ptoUpdateHistory-tab").on("click", function () {
            //    const container = $("#ptoUpdateHistory");
            //    if (container.find("#tlUpdateHistoryInfo").length === 0) {
            //        const baseUrl = $("body").data("base-url");
            //        const url = `${baseUrl}/Trademark/TLUpdate/GetUndoMenu`;
            //        $.get(url).done((result) => {
            //            container.html(result);
            //        });
            //    }
            //});
        });

    }

    //initializeRTSUpdatePage() {
    //    $("#inpCompareContainer").append($("#inpCompareSearchResults-Grid_pager"));
    //}

    loadUpdateScreen(updateType) {
        let updateScreen;

        const biblioScreen = $("#updateScreenBiblio");

        switch (updateType) {
            case "Biblio":
                updateScreen = biblioScreen;
                biblioScreen.show();
                //actionScreen.hide();
                break;
        }
        const contentTab = updateScreen.find(".accordion-content");
        contentTab.first().addClass("show");
        contentTab.first().show();
        updateScreen.find(".nav-link.active").first().addClass("show");

        if (updateScreen.html().length !== 0)
            return;

        const baseUrl = $("body").data("base-url");
        const url = `${baseUrl}/Patent/RTSUpdate/GetUpdateScreen`;
        $.get(url, { updateType: updateType }).done((result) => {
            updateScreen.html(result);
        });
    }

    initializeUpdateActions = (updateType) => {
        const self = this;
        const updateTypeOption = $(".rts-update-main").find(`.updateTypeOption.${updateType}`);

        updateTypeOption.on("click", ".update-type", function () {
            self.updateType = $(this).data("value");
            self.loadUpdateScreen($(this).data("value"));
        });
        self.loadUpdateScreen(updateTypeOption.find("a.active").data("value"));

        updateTypeOption.on("click", ".rtsUpdate", function () {
            const container = $("#updateScreen");
            const title = container.data("update-confirm-title");
            const updatePrompt = container.data("update-mass-msg");

            cpiConfirm.confirm(title, updatePrompt, () => {
                self.runUpdate();
            });
        });

        //updateTypeOption.on("click", ".tlPrint", this.print);
    }


    initializeBiblioUpdate = () => {
        const container = $("#tlBiblioContainer");
        container.append($("#tlBiblioUpdate-Grid_pager"));

        const biblioUpdateGrid = $("#tlBiblioUpdate");

        const baseUrl = $("body").data("base-url");

        $(document).ready(function () {
            //biblioUpdateGrid.on("click", "input[type='checkbox']", function () {
            //    const url = `${baseUrl}/Trademark/TLUpdate/BiblioUpdateSetting`;
            //    const checkBox = $(this);
            //    $.post(url, {
            //        tlTmkId: checkBox.data("id"),
            //        fieldName: checkBox.attr("name"),
            //        update: this.checked,
            //        tStamp: $(checkBox.closest("tr")).data("stamp")
            //    });
            //});

            //biblioUpdateGrid.on("click", ".update-indiv", function (e) {
            //    e.preventDefault();
            //    const parent = $($(this).parents("tr")[0]);
            //    const id = parent.data("id");

            //    const container = $("#updateScreen");
            //    const title = container.data("update-confirm-title");
            //    const updatePrompt = container.data("update-indiv-msg");

            //    cpiConfirm.confirm(title, updatePrompt, () => {

            //        const url = `${baseUrl}/Trademark/TLUpdate/UpdateBiblioRecord`;
            //        $.post(url, { tlTmkId: id })
            //            .done(function (result) {
            //                const grid = $("#tlBiblioUpdate-Grid").data("kendoListView");

            //                if (parseInt(grid.options.dataSource.pageSize) > 0)
            //                    grid.dataSource.pageSize(grid.options.dataSource.pageSize);
            //                else
            //                    grid.dataSource.read();

            //                pageHelper.showSuccess(result.success);
            //                pageHelper.handleEmailWorkflow(result);
            //            })
            //            .fail(function (e) {
            //                pageHelper.showErrors(e);
            //            });
            //    });
            //});

            const listView = $("#rtsBiblioUpdate-Grid").data("kendoListView");
            $("#rtsBiblioTable").find(".k-link").sorter(listView, true);
        });

    }

    
}





